import { Injectable } from '@angular/core';
import { BaseService } from '../../common/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Profile } from '../../common/interfaces/profile.interface';
import { map } from 'rxjs/operators';

@Injectable()
export class CommonProfileService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    findProfile(): Observable<Profile> {
        return this.http.get(this.getApiUrl() + '/profiles/my')
            .pipe(map((res: any) => res || null));
    }
}
